module.exports = __webpack_public_path__ + "img/sb_3@2x.7e637cff.png";